import { InternalTypeEnum, ControlBaseModel } from "./index";
import { IComplements, IControl } from "../abstraction/index";
import { InputType } from 'reactstrap/es/Input';

// Objet servant de base pour la gestion des composants de type Control (input, select, list, tableau, image...)
export class ControlModel extends ControlBaseModel implements IComplements {

	constructor() {
		super()

		this.Key = "";
		this.Value = "";

		this.Visible = true;
		this.Disable = false;

		this.Class = "";
		this.InlineStyle = "";

		this.TypeLenght = 0;
		this.Format = "";
		this.DataType = InternalTypeEnum.Alpha;
		this.IdPanel = "";

		this.RunActionMiddle = "";
		this.RunActionLeft = "";
		this.RunActionRight = "";

		this.PreviousValue = this.Value;
		this.IsDirty = false;
		this.ShowMoreOnLoad = false;
		this.AutoAction = "";
	}

	// Cr�e une nouvelle instance du control � partir du flux JSON re�u depuis X3 
	public static create(s: IControl): ControlModel {
		let c = new ControlModel();
		c.Key = s.Code;
		c.Id = s.Id;
		c.ControlType = s.Type;

		// IControl Init
		c.Description = s.Description;
		c.Value = s.Value;
		c.defaultValue = s.Value;
		c.Complement1 = s.Complement1;
		c.Complement2 = s.Complement2;
		c.Complement3 = s.Complement3;

		c.TypeLenght = s.TypeLenght;
		c.Visible = s.Visible;
		c.Disable = s.Disable;
		c.NoLabel = s.NoLabel;
		c.Label = s.Label;
		c.DataType = s.DataType;
		c.Popup = s.Popup;
		c.PreviousValue = s.Value;
		c.IsDirty = false;
		return c;
	}

	Value: string = "";
	InputInlineStyle: string;
	HasFocus: boolean;
	Min: number;
	Max: number;
	MinLength: number;
	MaxLength: number;
	PlaceHolder?: string;
	Disable: boolean;
	Required: boolean;
	Step: number;
	DataType: InternalTypeEnum;
	InputType: InputType;
	PreviousValue: string;
	IsDirty: boolean;
	OnChange: string;

	Popup: string;		// IO_ZPOPUP
	Description: string = "";

	defaultValue: string = ""
	NoLabel: number = 0;        // O_NOLIB
	Label: string = ""          // O_LIBDEF
	TypeLenght: number = 0;

	// Les 3 zones compl�ments + leur CSS (attributs)
	Complement1: string = "";
	Complement2: string = "";
	Complement3: string = "";

	Complement1CSS: string = "";
	Complement2CSS: string = "";
	Complement3CSS: string = "";

	Class: string;
	InlineStyle: string;
	Visible: boolean = true;
	Format: string;

	OnClick: string;


	ShowValidity: boolean = false;

	IdPanel: string;

	// Pour du contenu suppl�mentaires 
	// Images / RTF
	Content: string;
	ContentType: string;

	// Indique si le control doit etre affich� en pleine �cran
	// Images / RTF

	bsSize: string;
	ToUpperCase: boolean;

	PrependImage: string;	// Zone de clic gauche
	PrependText: string;
	PreVisibilityCond: string;

	RunActionLeft: string;		
	RunActionMiddle: string;	// Clic sur zone centrale
	RunActionRight: string;		// Clic sur zone droite

	AppendImage: string;
	AppendText: string;
	AppVisibilityCond: string;

	ErrorMessage: string;

	//#region Tab Attributes 

	DefaultSort: string;

	// Formules conditonelles pour couleur de fond des donn�es
	BgGreenCond: string;
	BgYellowCond: string;
	BgOrangeCond: string;
	BgRedCond: string;

	TabRowDblClick: string = "";			// ID de l'action � �x�cuter en cas de double clic on the line
	TabAction1: string = "";
	TabAction2: string = "";
	NormBarcod: string = "";
	BarCodCond: string = "";
	ValidCond: string = "";
	TabAutoSelectSingleRow: boolean = false;
	TabAutoSelectAction: string = "";

	TreeViewKeyPath: string = "";			// Binding sur colonne repr�sentant la cl� de la ligne en mode TreeView
	TreeViewParentKeyPath: string = "";		// Binding sur colonne repr�sentant la cl� de la ligne PARENT en mode TreeView
	TreeViewIsExpandedPath: string = "";	// Binding sur colonne indiquant si l'arbre est pli� (0) ou ouvert (1)
	TreeViewIconPath: string;				// Binding sur colonne indiquant le code icon� � afficher
	TreeViewLevelPath: string;				// Binding sur colonne indiquant le niveau dans l'arbre

	ShowAsGraph: boolean=false;
	GraphType: string;
	GraphXPath: string;
	GraphSeries: string;
	GraphSeriesColor: string;

	// valeur indiquant que si la zone est de type RTF ou Image, on affichera l'icone � la place du contenu. L'utilisateur devra alors cliqu� pour voir le contenu en plein �cran.
	ShowMoreIcon: string;
	ShowMoreOnLoad: boolean;
	//#endregion 

	//#region Progress Attributes

	ProgressColor: string;

	//#endregion

	//#region List attributes
	ShowAsButtonList: boolean;
	ButtonListColor: string = "default";
	ButtonListVerticalOrientation: boolean = false;
	//#endregion

	//#region Jauge Attributes

	JaugeSegments: number;
	JaugeStartColor: string;
	JaugeEndColor: string;

	//#endregion

	//#region  Gestion APN
	Camera: boolean;			// APN actif ou non
	AttachmentDest: string;		// Destination des prises de vue
	//#endregion

	// Indicateur sur l'�tat du panel (pli� ou non)
	DivCollapsed: boolean = false;

	// Chaine pour validation via expression r�guli�re
	Pattern: string;

	DrawMode: boolean;			// Autorisation de

	AutoAction: string;

	//#region Attributs sp�cifique KSelect

	// Attribut pour liste d�roulante indiquant que le bouton pour afficher la liste n'est pas disponible (masqu�)
	ListNoSelect: boolean;

	//#enregion
}

